import React, { useState } from 'react';
import { ShieldCheck, Zap, CreditCard, Lock } from 'lucide-react';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'elite'>('elite');
  const links = {
    base: 'https://pagos.recursosfitness.shop/cart/44085593047137:1',
    elite: 'https://pagos.recursosfitness.shop/cart/44085593145441:1'
  };
  const handleCTA = () => {
    window.location.href = links[selectedPlan];
  };
  return <section id="pricing" className="bg-gray-900 py-6 sm:py-10 px-4 sm:px-6 lg:px-8" data-id="element-276">
      <div className="max-w-3xl mx-auto" data-id="element-277">
        <div className="text-center mb-4 sm:mb-6" data-id="element-278">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-1" data-id="element-279">
            Elegí tu Profe de Natación Resuelto
          </h2>
          <p className="text-sm sm:text-base text-gray-400 font-medium" data-id="element-280">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:gap-4 mb-5" data-id="element-281">
          {/* Option 1: Base */}
          <div onClick={() => setSelectedPlan('base')} className={`relative rounded-xl border-2 p-3 sm:p-4 cursor-pointer transition-all flex flex-row items-center justify-between gap-3 ${selectedPlan === 'base' ? 'border-agua bg-gray-800/80 shadow-[0_0_20px_rgba(0,180,216,0.15)]' : 'border-gray-800 bg-gray-900/50 hover:border-gray-700'}`} data-id="element-282">
            <div className="flex items-center gap-3" data-id="element-283">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'base' ? 'border-agua' : 'border-gray-600'}`} data-id="element-284">
                {selectedPlan === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-agua" data-id="element-285" />}
              </div>
              <div data-id="element-286">
                <h3 className="text-white font-bold text-sm sm:text-base flex items-center gap-1.5" data-id="element-287">
                  <span data-id="element-288">📘</span> PROFE DE NATACIÓN RESUELTO
                </h3>
                <p className="text-gray-400 text-xs mt-0.5" data-id="element-289">
                  6 Tomos + 120 clases + bonos
                </p>
              </div>
            </div>
            <div className="text-right shrink-0 flex flex-col items-end" data-id="element-290">
              <div className="text-gray-500 line-through text-xs font-medium" data-id="element-291">
                $34.990
              </div>
              <div className="text-white text-2xl sm:text-3xl font-black leading-tight" data-id="element-292">
                $19.990
              </div>
            </div>
          </div>

          {/* Option 2: Elite */}
          <div onClick={() => setSelectedPlan('elite')} className={`relative rounded-xl border-2 p-3 sm:p-4 cursor-pointer transition-all flex flex-row items-center justify-between gap-3 ${selectedPlan === 'elite' ? 'border-agua bg-gray-800/80 shadow-[0_0_20px_rgba(0,180,216,0.15)]' : 'border-gray-800 bg-gray-900/50 hover:border-gray-700'}`} data-id="element-293">
            <div className="flex items-center gap-3" data-id="element-294">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'elite' ? 'border-agua' : 'border-gray-600'}`} data-id="element-295">
                {selectedPlan === 'elite' && <div className="w-2.5 h-2.5 rounded-full bg-agua" data-id="element-296" />}
              </div>
              <div data-id="element-297">
                <h3 className="text-white font-bold text-sm sm:text-base flex items-center gap-1.5" data-id="element-298">
                  <span data-id="element-299">🏆</span> PACK ÉLITE™
                </h3>
                <div className="flex flex-wrap gap-1.5 mt-1 mb-1" data-id="element-300">
                  <span className="bg-agua text-white text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded flex items-center gap-0.5" data-id="element-301">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="bg-transparent border border-agua text-agua text-[9px] sm:text-[10px] font-bold px-2 py-0.5 rounded" data-id="element-302">
                    AHORRÁS $16.000
                  </span>
                </div>
                <p className="text-gray-400 text-xs max-w-xs" data-id="element-303">
                  6 Tomos + 120 clases + bonos + Natación Competitiva + Escuela
                  Rentable
                </p>
              </div>
            </div>
            <div className="text-right shrink-0 flex flex-col items-end" data-id="element-304">
              <div className="text-gray-500 line-through text-xs font-medium" data-id="element-305">
                $43.990
              </div>
              <div className="text-agua text-2xl sm:text-3xl font-black leading-tight" data-id="element-306">
                $27.990
              </div>
            </div>
          </div>
        </div>

        <button onClick={handleCTA} className="w-full bg-agua hover:bg-agua-dark text-white font-black text-lg py-4 px-6 rounded-xl shadow-[0_8px_20px_rgba(0,180,216,0.3)] hover:shadow-[0_10px_25px_rgba(0,180,216,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mb-3" data-id="element-307">
          SÍ, QUIERO MI PACK →
        </button>

        <p className="text-center text-gray-400 text-xs italic mb-4" data-id="element-308">
          La opción más elegida por profes de natación de todo el país
        </p>

        <div className="border border-gray-800 bg-gray-900/50 rounded-lg p-3 flex flex-wrap justify-center items-center gap-3 sm:gap-6 text-xs font-medium text-gray-300" data-id="element-309">
          <div className="flex items-center gap-1.5" data-id="element-310">
            <Lock className="w-3.5 h-3.5 text-gray-400" data-id="element-311" /> Pago seguro
          </div>
          <div className="flex items-center gap-1.5" data-id="element-312">
            <Zap className="w-3.5 h-3.5 text-yellow-500" data-id="element-313" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-1.5" data-id="element-314">
            <ShieldCheck className="w-3.5 h-3.5 text-red-500" data-id="element-315" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5" data-id="element-316">
            <CreditCard className="w-3.5 h-3.5 text-blue-400" data-id="element-317" /> Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}